import { render, staticRenderFns } from "./production-task-list.vue?vue&type=template&id=0f18447a"
import script from "./production-task-list.vue?vue&type=script&lang=js"
export * from "./production-task-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports